export default __webpack_public_path__ + "static/AppLocation3-3dfa7033d0029176e376ca66701c3d76.png";